import { useEffect } from "react";
import Calendar from "../../../Component/calendar/calendar";
import { markNotificationScopeRead } from "../../../utils/notificationsApi";

function CalendarPro() {
  useEffect(() => {
    markNotificationScopeRead("rdv");
  }, []);

  return (
    <div>
      <Calendar />
    </div>
  );
}

export default CalendarPro;